import { render, staticRenderFns } from "./SfChevron.vue?vue&type=template&id=4287f925&functional=true"
import script from "./SfChevron.vue?vue&type=script&lang=js"
export * from "./SfChevron.vue?vue&type=script&lang=js"
import style0 from "./SfChevron.vue?vue&type=style&index=0&id=4287f925&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports